import React, { type ReactNode } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { gridSize, fontSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import emptySearchImage from '../../../assets/empty-search.svg';
import messages from './messages';
import type { Props } from './types';

export const TableEmptySearchView = (props: Props) => {
	const {
		intl: { formatMessage },
	} = props;
	return (
		<ImageWrapper data-testid="users-and-roles.ui.actors-table.table-filter-empty-view">
			<img alt="" src={emptySearchImage} />
			<TextWrapper>{formatMessage(messages.noMatchingResult)}</TextWrapper>
			<DescriptionWrapper>{formatMessage(messages.changeFilter)}</DescriptionWrapper>
		</ImageWrapper>
	);
};

export default injectIntl(TableEmptySearchView);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageWrapper = styled2.div<{
	children?: ReactNode;
	['data-testid']: string;
}>({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	marginTop: `${gridSize * 15}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextWrapper = styled.h3<{
	children?: ReactNode;
}>({
	margin: token('space.100', '8px'),
	marginTop: token('space.300', '24px'),
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 60}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DescriptionWrapper = styled2.div({
	margin: token('space.100', '8px'),
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 70}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSize}px`,
});
